var UA = require('../internals/engine-user-agent');

module.exports = /MSIE|Trident/.test(UA);



//////////////////
// WEBPACK FOOTER
// /tmp/build_310c34ba/node_modules/core-js/internals/engine-is-ie-or-edge.js
// module id = 456
// module chunks = 2